import React from 'react';
import {Outlet} from "react-router-dom";
import Header from "./components/app/header";
import Footer from "./components/app/footer";

function App() {
    return (
        <div className="App h-min-[100vh] w-full m-0 bg-0">
            <Header />
            <Outlet />
            <Footer />
        </div>
    );
}

export default App;
